import { AiOutlineCloseCircle } from 'react-icons/ai';

const Modal = ({ children, closeModal = () => {} }) => {
  return (
    <div className="fixed w-full h-full left-0 top-0 z-40 flex justify-center items-center">
        <div className="bg-overlay absolute w-full h-full left-0 top-0 bg-black" onClick={closeModal} />

        <div className="relative z-10">
            <header className="flex justify-end pb-3 text-white">
                <button className="translate-x-full" onClick={closeModal}>
                    <AiOutlineCloseCircle className="text-2xl"/>
                </button>
            </header>
            <div className="content bg-white p-7 rounded-md">
                { children }
            </div>
        </div>
    </div>
  )
}

export default Modal